<div class="button-container">
  <div class="flex-row">
    <div class="filters-container">
      <cv-input
        [value]="searchText"
        [type]="'text'"
        [name]="'Searchby'"
		    label="Title"
        [maxlength]="100"
        [placeholder]="'Search by title'"
        class="filter-input input-title"
        (controlKeyup)="onSearchTextChange('title', $event)"
      ></cv-input>

      <cv-dropdown
    	class="filter-input app-switch-dropdown"
        label="Origin"
        optionText="name"
        optionValue="id"
		[selectedValue]="originSelected"
		[options]="originOptions"
		(valuesChange)="onFilterChange('origin', $event)"
      >
      </cv-dropdown>

      <cv-dropdown
        class="filter-input app-switch-dropdown"
        label="Active"
        optionText="name"
        optionValue="id"
		[selectedValue]="activeSelected"
		[options]="activeOptions"
		(valuesChange)="onFilterChange('active', $event)">
      </cv-dropdown>
    </div>

    <button class="btn btn-sm cv-btn-blue" (click)="onAddProduct()">
      <i class="fas fa-plus"></i> Create Product
    </button>
  </div>
</div>

<div class="datatable-content products-grid-table scrollable-component">
  <ag-grid-angular
    #grid
    class="ag-theme-balham custom-grid"
    [enableCellTextSelection]="true"
    (gridReady)="onInitializeGrid($event)"
    (gridSizeChanged)="resizeToFitColumns()"
    [pagination]="true"
    [suppressPaginationPanel]="true"
    [gridOptions]="gridOptions"
    [domLayout]="'autoHeight'"
    [rowData]="gridData"
  >
  </ag-grid-angular>

  <cv-grid-pagination
    [pagination]="gridPagination.pagination"
    (onPaginationChange)="onPaginationChange($event)"
  >
  </cv-grid-pagination>

  <!--<button pButton (click)="openNewProductsConfiguration()">New</button>-->
</div>
